/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { UserForOrganizationSitesAdminRequest } from '../../models/user-for-organization-sites-admin-request';

export interface PutAdministrationOrganizationSitesUser$Params {
  userKey: KeyType;
      body: UserForOrganizationSitesAdminRequest
}

export function putAdministrationOrganizationSitesUser(http: HttpClient, rootUrl: string, params: PutAdministrationOrganizationSitesUser$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, putAdministrationOrganizationSitesUser.PATH, 'put');
  if (params) {
    rb.path('userKey', params.userKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

putAdministrationOrganizationSitesUser.PATH = '/administration/organization-sites/users/{userKey}';
